export default __webpack_public_path__ + "static/media/Youtube.7c96c3db.svg";